import { useRecoilValue } from 'recoil';

import { basketCustomerOrderResumeState } from '../../../store/batchTicket/atom';

export const useBatchTicketTotalSummary = () => {
  const totalSummaryData = useRecoilValue(basketCustomerOrderResumeState).data.valid;

  return { totalSummaryData };
};
